export default {
	namespaced: true,
	state: () => ({
		isLoginModalShow: false,
	}),
	getters: {
		getLoginModalShow: (state) => {
			return state.isLoginModalShow;
		},
	},
	mutations: {
		setLoginModalShow: (state, data) => {
			state.isLoginModalShow = data;
		},
	}
}
